import { Component } from '@angular/core';
import { CommonExplainModule } from '../../common-explain/common-explain.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SmartSearchPromptModule } from '../../shared/modules/smart-search-prompt/smart-search-prompt.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-feature-modal-smart-search',
  standalone: true,
  imports: [CommonExplainModule, ReactiveFormsModule, SmartSearchPromptModule, TranslateModule],
  templateUrl: './feature-modal-smart-search.component.html',
  styleUrl: './feature-modal-smart-search.component.scss',
})
export class FeatureModalSmartSearchComponent {
  constructor(protected modal: NgbActiveModal) {}
}
